import { render, staticRenderFns } from "./fuwenben.vue?vue&type=template&id=3cff7f22&scoped=true"
import script from "./fuwenben.vue?vue&type=script&lang=js"
export * from "./fuwenben.vue?vue&type=script&lang=js"
import style0 from "./fuwenben.vue?vue&type=style&index=0&id=3cff7f22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cff7f22",
  null
  
)

export default component.exports